import { App } from 'vue';
import ColorPicker from './ColorPicker.vue';

export default function config(app: App): void {
    app.component('ColorPicker', ColorPicker);
}
